import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import MultiSelect from '@khanacademy/react-multi-select'

const sortingOptions = [{
  label: 'Rank',
  value: 'reputation',
}, {
  label: 'Models count',
  value: 'model_count',
}, {
  label: 'Rating',
  value: 'rating',
}, {
  label: 'Best match',
  value: 'relevance',
}]

function FiltersBar({
  onFiltersChange,
  onSortChange,
  filters,
  availableSkillOptions,
  availableSoftwareOptions,
}) {
  const getMatchingOptions = (filter) => {
    return filter === 'skills' ? availableSkillOptions : availableSoftwareOptions
  }

  const trackFilterChange = ({ name, value }) => {
    const { keywords } = filters

    window.filterTracker({
      name,
      value,
      searchTerm: keywords || '',
      type: '3d designer',
    })

    window.searchTracker({
      searchTerm: keywords || '',
      type: '3d designer',
    })
  }

  const handleOpenForHireChange = (value) => {
    if (value) {
      trackFilterChange({ name: 'Open for hire', value: 'Open for hire' })
    } else {
      window.removeCurrentSearchFilter({ name: 'Open for hire' })
    }

    onFiltersChange({
      ...filters,
      isOpenForHire: value,
    })
  }

  const handleFiltreChange = (filter, value) => {
    const currentFilters = filters[filter] || []
    const isFilterSelected = value.length > currentFilters.length
    const isFilterDeselected = value.length < currentFilters.length

    if (isFilterSelected) {
      const newFilter = value
        .filter((element) => currentFilters.every((currentValue) => currentValue !== element))

      if (newFilter.length) {
        const currentValue = newFilter.pop()
        const matchingLabels = getMatchingOptions(filter)
        const selectedLabel = matchingLabels.find(option => option.value === currentValue)
        const matchingLabel = selectedLabel ? selectedLabel.label : ''

        trackFilterChange({ name: filter, value: matchingLabel })
      }
    }

    if (isFilterDeselected) {
      const removedFilter = currentFilters
        .filter((element) => value.every((currentValue) => currentValue !== element))

      if (removedFilter.length) {
        const currentValue = removedFilter.pop()
        const matchingLabels = getMatchingOptions(filter)
        const selectedLabel = matchingLabels.find(option => option.value === currentValue)
        const matchingLabel = selectedLabel ? selectedLabel.label : ''

        window.removeCurrentSearchFilter({
          name: filter,
          value: matchingLabel,
        })
      }
    }

    onFiltersChange({
      ...filters,
      [filter]: value,
    })
  }

  return (
    <div className="designer-list__filters">
      <div className="designer-list__filters-left">
        <div className="custom-dropdown--dark">
          <MultiSelect
            options={availableSkillOptions}
            onSelectedChanged={(value) => { handleFiltreChange('skills', value) }}
            selected={filters.skills}
            placeholder="Skills"
            hasSelectAll={false}
            disableSearch
          />
        </div>
        <div className="custom-dropdown--dark">
          <MultiSelect
            options={availableSoftwareOptions}
            onSelectedChanged={(value) => { handleFiltreChange('software', value) }}
            selected={filters.software}
            placeholder="Software"
            hasSelectAll={false}
          />
        </div>
        <div className="designer-list__filters-open-for-hire heading-16">
          <input
            id="open-for-hire"
            type="checkbox"
            className="checkbox"
            checked={filters.isOpenForHire}
            onChange={(e) => { handleOpenForHireChange(e.target.checked || false) }}
          />
          <label htmlFor="open-for-hire">Open for hire</label>
        </div>
      </div>
      <div className="designer-list__filters-right">
        <Select
          name="projects-list-sort"
          value={filters.sortBy}
          options={sortingOptions}
          onChange={(option) => onSortChange({
            ...filters,
            sortBy: option.value,
          })}
          placeholder="Sort"
          className="Select-outline Select--dark"
          searchable={false}
          clearable={false}
        />
      </div>
    </div>
  )
}

FiltersBar.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  availableSkillOptions: PropTypes.array.isRequired,
  availableSoftwareOptions: PropTypes.array.isRequired,
}

export default FiltersBar
